import { render, staticRenderFns } from "./ChecklistFieldModule.vue?vue&type=template&id=9001aed6&scoped=true"
import script from "./ChecklistFieldModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChecklistFieldModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChecklistFieldModule.vue?vue&type=style&index=0&id=9001aed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9001aed6",
  null
  
)

export default component.exports